import apiClient from "./apiClient";
const resource = "cleaning";

export default {
  async getAll(params = {}) {
    return apiClient.get(`${resource}`, { params });
  },

  async start(data) {
    return apiClient.post(`${resource}/start`, data);
  },

  async finish(data) {
    return apiClient.post(`${resource}/finish`, data);
  },

  async search(keyword) {
    return apiClient.get(`${resource}/search?keyword=${keyword}`);
  },
};
